import { CancelTokenSource } from 'axios';

import BaseAPI from 'utils/api/base';

import { APIRequest } from 'utils/api/types';

import { ControlEvidenceRow, ControlPutInPlace, RiskActionDetail } from './risks.types';

class RisksAPI extends BaseAPI {
  loadRiskAction = (uuid: string, cancelTokenSource?: CancelTokenSource): APIRequest<RiskActionDetail> => {
    const url = `/risks/actions/${uuid}/`;
    const method = 'GET';

    return this.request<RiskActionDetail>({ url, method, cancelTokenSource });
  };

  submitControlEvidence = (uuid: string, text: string, files: File[]): APIRequest<RiskActionDetail> => {
    const url = `/risks/actions/${uuid}/evidence/`;
    const method = 'POST';

    const data = new FormData();
    data.append('text', text);
    files.forEach((file) => data.append('files', file));

    return this.request<RiskActionDetail>({ url, method, data });
  };

  loadControlEvidence = (
    controlUuid: string,
    cancelTokenSource?: CancelTokenSource
  ): APIRequest<ControlEvidenceRow[]> => {
    const url = `/entities/controls/${controlUuid}/evidence/`;
    const method = 'GET';

    return this.request<ControlEvidenceRow[]>({ url, method, cancelTokenSource });
  };

  loadControlPutInPlace = (
    controlUuid: string,
    cancelTokenSource?: CancelTokenSource
  ): APIRequest<{ putInPlace: ControlPutInPlace | null }> => {
    const url = `/entities/controls/${controlUuid}/put-in-place/`;
    const method = 'GET';

    return this.request<{ putInPlace: ControlPutInPlace | null }>({ url, method, cancelTokenSource });
  };
}

export default RisksAPI;
